import { render, staticRenderFns } from "./UpdateRxProviderModal.vue?vue&type=template&id=55d31598"
import script from "./UpdateRxProviderModal.vue?vue&type=script&lang=ts"
export * from "./UpdateRxProviderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports